import React from "react"

export const EDIT_COMMENTS_ITEM_MOD_SUMMARY_VERSION = (modVersion, gameVersion) => {
    let NBSP = `\u00a0`
    return (
        <React.Fragment>
            <mark>{modVersion}</mark>{NBSP}для{NBSP}<mark>MT{NBSP}{gameVersion}</mark>
        </React.Fragment>
    )
}

export const EDIT_COMMENTS_AUTHOR = (author, isHidden) => {
    if (isHidden === 0) {
        return <React.Fragment>{author} <p style={{color:"var(--lightyellow-color)",fontSize:"10px",display:"inline-block",fontWeight:100,textTransform:"uppercase"}}>[проверяется]</p></React.Fragment>
    } else if (isHidden === 3) { 
        return <React.Fragment>{author} <p style={{color:"var(--red-color)",fontSize:"10px",display:"inline-block",fontWeight:100,textTransform:"uppercase"}}>[жалоба]</p></React.Fragment>
    } else if (isHidden === 2) { 
        return <React.Fragment>{author} <p style={{color:"var(--all-text-20c-color)",fontSize:"10px",display:"inline-block",fontWeight:100,textTransform:"uppercase"}}>[скрыт]</p></React.Fragment>
    } else {
        return `${author}`
    }
}

export const EDIT_COMMENTS_MODERATOR_CAPTION = "Модератор"

export const EDIT_COMMENTS_MODERATOR_CAPTIONS = (isHidden) => {
    if (isHidden === 0) {
        return <React.Fragment>{EDIT_COMMENTS_MODERATOR_CAPTION} <p style={{color:"var(--lightyellow-color)",fontSize:"10px",display:"inline-block",fontWeight:100,textTransform:"uppercase"}}>[проверяется]</p></React.Fragment>
    } else if (isHidden === 3) { 
        return <React.Fragment>{EDIT_COMMENTS_MODERATOR_CAPTION} <p style={{color:"var(--red-color)",fontSize:"10px",display:"inline-block",fontWeight:100,textTransform:"uppercase"}}>[жалоба]</p></React.Fragment>
    } else if (isHidden === 2) { 
        return <React.Fragment>{EDIT_COMMENTS_MODERATOR_CAPTION} <p style={{color:"var(--all-text-20c-color)",fontSize:"10px",display:"inline-block",fontWeight:100,textTransform:"uppercase"}}>[скрыт]</p></React.Fragment>
    } else {
        return EDIT_COMMENTS_MODERATOR_CAPTION
    }
}

export const EDIT_COMMENTS_MODERATOR_CAPTION_U = (userName, isHidden) => {
    if (isHidden === 0) {
        return <React.Fragment>{userName} (Вы) <p style={{color:"var(--lightyellow-color)",fontSize:"10px",display:"inline-block",fontWeight:100,textTransform:"uppercase"}}>[проверяется]</p></React.Fragment>
    } else if (isHidden === 3) { 
        return <React.Fragment>{userName} (Вы) <p style={{color:"var(--red-color)",fontSize:"10px",display:"inline-block",fontWeight:100,textTransform:"uppercase"}}>[жалоба]</p></React.Fragment>
    } else if (isHidden === 2) { 
        return <React.Fragment>{userName} (Вы) <p style={{color:"var(--all-text-20c-color)",fontSize:"10px",display:"inline-block",fontWeight:100,textTransform:"uppercase"}}>[скрыт]</p></React.Fragment>
    } else {
        return `${userName} (Вы)`
    }
}
